import React from 'react'
import './container4.css';
export default function Container4() {
  return (
    <div className='container my-5'>
   
    <div className='row pt-3 contflex4'>
    <div className='col-lg-6 col-md-12 col-sm-12 contf14'>
    <h1 className='fw-bold py-2 d-none d-lg-block fs-2'>Moderne Bildschirme</h1>
        <p className='pb-4 cont3para'>Pii Screen Werbenetzwerk ist die perfekte Wahl für Autohäuser, Werkstätten, TÜV, … das Deine Werbung auf die nächste Stufe heben wird. Mit unserer Plattform kannst Du gezielt Deine Zielgruppe erreichen und Deine Werbung auf den wichtigsten digitalen Bildschirmen schalten. So stellst Du sicher, dass Deine Werbebotschaften genau dort ankommen, wo sie gebraucht werden.</p>
        <a href='https://werbenetzwerk.piiscreen.de/kontakt-formular' className='flinktext text-success1'><button className='btn btn-success'>Bildschirm anfragen</button></a>
    </div>
    <div className='col-lg-6 col-md-12 col-sm-12 contf24'>
    <h1 className='fw-bold py-2  d-lg-none fs-2' id='contf2headc'>Moderne Bildschirme</h1>
        <img src="./cont4.jpg" className='img-fluid text-center my-1' alt='not found'/>
    </div>
    </div>
    
</div>
  )
}
